export const GET_PAYMENTS = {
  INITIATE: 'GET_PAYMENTS_INITIATE',
  SUCCESS: 'GET_PAYMENTS_SUCCESS',
  FAILED: 'GET_PAYMENTS_FAILED',
};

export const UPSERT_PAYMENT = {
  INITIATE: 'UPSERT_PAYMENT_INITIATE',
  SUCCESS: 'UPSERT_PAYMENT_SUCCESS',
  FAILED: 'UPSERT_PAYMENT_FAILED',
};

export const ONLINE_PAYMENT_INFO = {
  INITIATE: 'ONLINE_PAYMENT_INFO_INITIATE',
  SUCCESS: 'ONLINE_PAYMENT_INFO_SUCCESS',
  FAILED: 'ONLINE_PAYMENT_INFO_FAILED',
};

export const GET_PAYMENT_DEBITS = {
  INITIATE: 'GET_PAYMENT_DEBITS_INITIATE',
  SUCCESS: 'GET_PAYMENT_DEBITS_SUCCESS',
  FAILED: 'GET_PAYMENT_DEBITS_FAILED',
};

export const SET_UPLOAD_MSG = 'SET_UPLOAD_MSG';
export const SET_CHECKOUT_STATUS = 'SET_CHECKOUT_STATUS';
export const PAYMENT_STATES_VALIDATION_STATUS_CHANGE =
  'PAYMENT_STATES_VALIDATION_STATUS_CHANGE';
export const PAYMENT_STATES_INITIATE_CHECKOUT =
  'PAYMENT_STATES_INITIATE_CHECKOUT';
export const PAYMENT_STATES_MARK_ORDER_CREATED =
  'PAYMENT_STATES_MARK_ORDER_CREATED';
export const PAYMENT_STATES_CHECKOUT_FAILED = 'PAYMENT_STATES_CHECKOUT_FAILED';

export const upsertPaymentInitiate = payload => ({
  type: UPSERT_PAYMENT.INITIATE,
  payload,
});

export const upsertPaymentFailed = err => ({
  type: UPSERT_PAYMENT.FAILED,
  err,
});

export const upsertPaymentSuccess = () => ({
  type: UPSERT_PAYMENT.SUCCESS,
});

export const getAllPaymentsInitiate = payload => ({
  type: GET_PAYMENTS.INITIATE,
  payload,
});

export const getAllPaymentsFailed = err => ({
  type: GET_PAYMENTS.FAILED,
  err,
});

export const getAllPaymentsSuccess = paymentsData => ({
  type: GET_PAYMENTS.SUCCESS,
  paymentsData,
});

export const getOnlinePaymentInfoInitiate = payload => ({
  type: ONLINE_PAYMENT_INFO.INITIATE,
  payload,
});

export const getOnlinePaymentInfoSuccess = paymentInfo => ({
  type: ONLINE_PAYMENT_INFO.SUCCESS,
  paymentInfo,
});

export const getOnlinePaymentInfoFailure = err => ({
  type: ONLINE_PAYMENT_INFO.FAILED,
  err,
});

export const paymentsStateValidationStatusChange = payload => {
  return {
    type: PAYMENT_STATES_VALIDATION_STATUS_CHANGE,
    payload: {
      status: payload?.status ?? false,
    },
  };
};

export const paymentStateMarkOrderCreated = ({ orderId, paymentHash }) => {
  return {
    type: PAYMENT_STATES_MARK_ORDER_CREATED,
    payload: {
      orderId,
      paymentHash,
    },
  };
};

export const paymentStateCheckoutFailure = () => {
  return {
    type: PAYMENT_STATES_CHECKOUT_FAILED,
  };
};

export const getPaymentDebitsInitiate = payload => ({
  type: GET_PAYMENT_DEBITS.INITIATE,
  payload,
});

export const getPaymentDebitsFailed = err => ({
  type: GET_PAYMENT_DEBITS.FAILED,
  err,
});

export const getPaymentDebitsSuccess = paymentDebitsData => ({
  type: GET_PAYMENT_DEBITS.SUCCESS,
  paymentDebitsData,
});
